export const shouldStageMessageForTurnHandoff = ({
  isChatLoading,
  isTurnActive,
}: {
  isChatLoading: boolean;
  isTurnActive: boolean;
}) => isChatLoading || isTurnActive;
